import { useEffect, useRef, useState } from "react";

import {
	EVENTO_PERFIL_DO_CARGO,
	EVENTO_PREFS_TICKETS,
	gravarPrefTickets,
	itensTravadosDe,
	lerPrefTickets,
} from "../../services/prefsTickets";

// Igual ao useState, só que lembra. Troque `useState(padrao)` por
// `usePrefTickets("chave", padrao)` e a escolha sobrevive ao F5 e à troca de
// máquina.
// Itens novos do catálogo entram na leitura (ver `comNovos` em prefsTickets).
const usePrefTickets = (chave, padrao) => {
	const [valor, setValor] = useState(() => lerPrefTickets(chave, padrao));
	// O último valor que veio da LEITURA (abertura, cargo, outra tela). Só o
	// que difere dele foi a pessoa quem mudou: abrir a tela, ou reler porque o
	// cargo chegou, não grava nada.
	const lido = useRef(valor);
	const reler = () => {
		lido.current = lerPrefTickets(chave, padrao);
		setValor(lido.current);
	};

	useEffect(() => {
		if (valor === lido.current) return;

		gravarPrefTickets(chave, valor);
	}, [chave, valor]);

	// O perfil do cargo chega depois da tela montar (é uma requisição), e ele
	// muda o que vale: reler quando chegar.
	useEffect(() => {
		window.addEventListener(EVENTO_PERFIL_DO_CARGO, reler);
		return () => window.removeEventListener(EVENTO_PERFIL_DO_CARGO, reler);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [chave]);

	// Outra tela mexeu na mesma preferência: obedecer, senão duas partes da
	// tela mostram coisas diferentes até alguém recarregar.
	useEffect(() => {
		const atualizar = (e) => {
			if (e.detail?.chave !== chave) return;
			reler();
		};

		window.addEventListener(EVENTO_PREFS_TICKETS, atualizar);
		return () => window.removeEventListener(EVENTO_PREFS_TICKETS, atualizar);
		// `padrao` costuma ser literal e mudaria de identidade a cada render.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [chave]);

	// O terceiro item é para a tela de personalização: quais ids o cargo não
	// deixa mexer. Quem só lê a preferência ignora, como sempre fez.
	return [valor, setValor, itensTravadosDe(chave)];
};

export default usePrefTickets;
